<template>
    <div class="modal p-4 col-12 position-fixed d-flex justify-content-center align-items-center">
        <el-card :class="cardclass" :footer="footer" class="d-block">
            <template #header>
                <div class="col-12 row justify-content-between p-1 position-relative">
                    <div class="col-auto">
                        {{ header }}
                    </div>
                    <div class="col-auto p-0 m-x position-absolute" style="right: 0;">
                        <el-icon style="cursor: pointer;" role="button" @click="close">
                            <Close />
                        </el-icon>
                    </div>
                </div>
            </template>
            <slot></slot>
        </el-card>
    </div>
</template>

<script>
    export default {
        name: 'ModalComponent',
        props: {
            header: String,
            footer: String,
            cardclass: String
        },
        emits: ['close'],
        methods: {
            close() {
                this.$emit('close')
            }
        }
    }
</script>
